import { Box, Text } from "theme-ui";
import { useState } from "react";
import { useDispatch } from "react-redux";
import flow from "lodash/fp/flow";
import keys from "lodash/fp/keys";
import map from "lodash/fp/map";

import { updateUserChoiceValues } from "store/app/appSlice";
import { Button } from "components";
import { CustomizeIcon } from "components/icons";
import ModalCenterEnlarged from "../ModalCenterEnlarged";
import * as styles from "./ModalSelectProCustomGraphic.styles";

export default function ModalSelectProCustomGraphic({
  isTopMostModal,
  onClose,
  customisation,
  title,
  text,
  description,
}) {
  const dispatch = useDispatch();

  const initialUserChoices = customisation.fields.reduce(
    (acc, curr) => ({
      ...acc,
      [curr.name]: curr.defaultValue,
    }),
    {}
  );

  const [formValues, setFormValues] = useState({
    ...initialUserChoices,
  });

  const dispatchUpdateUserChoiceValues = (fieldValue) => {
    dispatch(updateUserChoiceValues(fieldValue));
  };
  //defines what values of Graphic to be submitted into userChoiceValues
  const userProCustomChoiceValuesToSubmit = (values) =>
    flow(
      keys,
      map((field) => ({
        name: field,
        value: values[field],
      }))
    )(values);

  const handleSubmit = (evt) => {
    evt.preventDefault();
    flow(
      userProCustomChoiceValuesToSubmit,
      dispatchUpdateUserChoiceValues,
      onClose
    )(formValues);
  };

  return (
    <>
      <ModalCenterEnlarged
        isTopMostModal={isTopMostModal}
        onClose={onClose}
        disableEscapeKey
        background={"transparent"}
        boxShadow={"none"}
        modalContainerStyles={{ padding: "45px 15px" }}
      >
        <Box sx={styles.selectGraphicModal}>
          <Box sx={styles.modalHeader}>
            <Text variant="h5" sx={styles.modalTitle}>
              {title}
            </Text>
            <Text variant="h3Light" sx={styles.modalText}>
              {text}
            </Text>
            <Text variant="h2Light" sx={styles.modalDescription}>
              {description}
            </Text>
          </Box>
          <Box as="form" onSubmit={handleSubmit} sx={styles.contentContainer}>
            {customisation.fields[0].options.map(
              ({ name, label, title, value, imageURLValue }) => {
                return (
                  <Box key={label} sx={styles.contentCard}>
                    <Box
                      sx={styles.image({
                        backgroundImageUrl: imageURLValue,
                      })}
                    />
                    <Box sx={styles.buttonContainer}>
                      <Button
                        type="submit"
                        variant="primary"
                        size="medium"
                        isRound
                        theme="dark"
                        buttonInnerNoDiv
                        iconBefore={<CustomizeIcon />}
                        onClick={() => {
                          setFormValues((prevState) => ({
                            ...prevState,
                            [name]: value,
                          }));
                        }}
                      >
                        {title}
                      </Button>
                    </Box>
                  </Box>
                );
              }
            )}
          </Box>
        </Box>
      </ModalCenterEnlarged>
    </>
  );
}
